<template>
  <textarea
    v-bind="$attrs"
    :value="value"
    @blur="$emit('input', $event.target.value)"
    rows="2"
    :class="{
      'f-border-red-300 focus:f-ring-red-500 focus:f-border-red-500 f-text-red-900 f-placeholder-red-300':
        error,
    }"
    class="f-form-textarea f-block f-w-full f-border-gray-300 focus:f-outline-none f-rounded-md f-text-gray-700"
  ></textarea>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseTextarea",
  props: {
    value: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
  },
});
</script>
